import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import {
  ApiProperty,
  ApiPropertyOptional,
  IntersectionType,
} from '@nestjs/swagger';
import { ArchivableEntityDto } from '../../common/dto/archivable-entity.dto';
import { UserDto } from '../../user/dto/user.dto';
import { SubdivisionDto } from '../../subdivision/dto/subdivision.dto';
import { SubdivisionSupervisorInterface } from '../interfaces/subdivision-supervisor.interface';
import { UserPublicInterface } from 'src/modules/user/interfaces/user-public.interface';

@Exclude()
export class SubdivisionSupervisorDto
  extends IntersectionType(CommonEntityDto, ArchivableEntityDto)
  implements SubdivisionSupervisorInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated subdivision ID',
  })
  @IsUUID()
  @Expose()
  subdivisionId!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'User',
    description: 'The user associated with this subdivision',
  })
  @Expose()
  user?: UserPublicInterface;

  @ApiPropertyOptional({
    type: () => [SubdivisionDto],
    title: 'Subdivision',
    description: 'The subdivision associated with this user',
  })
  @Expose()
  subdivision?: SubdivisionDto;
}
